import { Component, OnInit, ElementRef, ViewChild, Renderer2, RendererStyleFlags2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {SettingsService} from "@app/services/shared/settings.service";
import {UserService} from "@app/services/shared/user.service";

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
    showFooter = true;
    @ViewChild('sectionContainer', { static: true }) sectionContainer: ElementRef;
    constructor(private router: Router, private renderer: Renderer2,
                public settingsService: SettingsService,
                private  userService: UserService) {
      this.router.events
        .pipe(
          filter(
            (event) => {
              return (event instanceof NavigationEnd);
            }
          )
        )
        .subscribe(
          async (event: NavigationEnd) => {
            if (event.url
              && (event.url.includes("drawing-helper")
                || (event.url == "/"
                  && await this.userService.hasPermissionForUrl('/drawing-helper/drawing-helper').toPromise()))) {
              this.showFooter = false;
              this.renderer.addClass(this.sectionContainer.nativeElement, "reduce-bottom-margin");
            } else {

              this.showFooter = true;
              this.renderer.removeClass(this.sectionContainer.nativeElement, "reduce-bottom-margin");
            }
          }
        );
    }

    public ngOnInit() {
    }
}
